
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1861"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1861"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $e02d6e1ed9a7b79b$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["f9fpV","index.f30ab698.js","21qUI","icons.448fab21.svg"]'));

class $c9f2caaecf229584$var$FilterView {
    _parentElement = document.querySelector(".find-country__filter-countries");
    _filterByRegion = document.querySelector('label[for = "filter-options"');
    _filterByRegionContainer = document.querySelector(".find-country__filter-countries");
    constructor(){
        // this._addHandlerHandleDropDown();
        // this._addHandlerCloseDropDown();
        this._addHandlerFocus();
    }
    _addHandlerFocus() {
        this._filterByRegionContainer.addEventListener("click", function(e) {
            const label = e.target.closest("label[for='filter-options']");
            if (label) {
                const filterRegionList = document.querySelector(".find-country__filter-region-list");
                filterRegionList.focus();
            }
        });
    }
    _addHandlerNavigationByKeyboard(handler) {
        this._filterByRegionContainer.addEventListener("keyup", function(e) {
            const filterRegion = e.target.closest(".find-country__filter-region-item");
            const label = e.target.closest(".find-country__filter-mode");
            if (label) {
                if (e.key !== "Enter") return;
                const filterRegionList = document.querySelector(".find-country__filter-region-list");
                filterRegionList.focus();
            } else if (filterRegion) {
                if (e.key !== "Enter") return;
                const filterRegionItem = filterRegion.textContent.trim().toLowerCase();
                handler(filterRegionItem);
            }
        });
    }
    _addHandlerCloseDropDown() {
        document.addEventListener("click", (function(e) {
            const insideFilterCountries = e.target.closest(".find-country__filter-countries");
            const clickDarkMode = e.target.closest(".theme-switcher");
            const clickInsideSearchInput = e.target.closest(".find-country__search");
            const clickTheTitle = e.target.closest(".title");
            const expandIcon = document.querySelector(".find-country__filter-icons");
            const expandIconSronlyText = expandIcon.querySelector(".sr-only");
            //if the user clicks outside of the filter countries close the drop down
            if (!insideFilterCountries && !clickDarkMode && !clickInsideSearchInput && !clickTheTitle) {
                if (expandIconSronlyText.innerText.includes("expand")) {
                    const targetIconElement = expandIconSronlyText.previousElementSibling;
                    targetIconElement.classList.remove("fa-chevron-down");
                    targetIconElement.classList.add("fa-chevron-up");
                    this._parentElement.classList.remove("expand-drop-down");
                    this._parentElement.classList.add("collapse");
                    expandIconSronlyText.innerText = "arrow collapse";
                    setTimeout(()=>{
                        this._parentElement.classList.remove("collapse");
                        this._parentElement.classList.add("not-open");
                    }, 500);
                }
            }
        }).bind(this));
    }
    _addHandlerHandleDropDown() {
        this._parentElement.addEventListener("click", (function(e) {
            const filterContainer = e.target.closest(".find-country__filter-countries__wrapper");
            /*return from the function when the user clicks outside of the collapse icon*/ if (!filterContainer) return;
            const targetElement = this._parentElement.querySelector(".sr-only");
            const expandedIcon = targetElement.previousElementSibling;
            if (targetElement.innerText.includes("expanded")) {
                expandedIcon.classList.remove("fa-chevron-down");
                expandedIcon.classList.add("fa-chevron-up");
                this._parentElement.classList.remove("expand-drop-down");
                this._parentElement.classList.add("collapse");
                targetElement.innerText = "arrow collapse";
                setTimeout(()=>{
                    this._parentElement.classList.remove("collapse");
                    this._parentElement.classList.add("not-open");
                }, 500);
            } else if (targetElement.innerText.includes("collapse")) {
                expandedIcon.classList.remove("fa-chevron-up");
                expandedIcon.classList.add("fa-chevron-down");
                this._parentElement.classList.remove("not-open");
                this._parentElement.classList.add("expand-drop-down");
                this._parentElement.classList.remove("collapse");
                targetElement.innerText = "arrow expanded";
            }
        }).bind(this));
    }
    _addHandlerFilterByRegion(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const filterRegion = e.target.closest(".find-country__filter-region-item");
            if (!filterRegion) return;
            const filterRegionItem = filterRegion.textContent.trim().toLowerCase();
            handler(filterRegionItem);
        });
    }
}
var $c9f2caaecf229584$export$2e2bcd8739ae039 = new $c9f2caaecf229584$var$FilterView();


const $ba30e20475feac5a$export$923ea8233b386e99 = "https://restcountries.com/v3.1";
const $ba30e20475feac5a$export$99104383344c6243 = 10;
const $ba30e20475feac5a$export$220312718d013f63 = "wrong country data";


const $d3824bf2ef2465db$var$timeout = function(TIME_OUT_SEC) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long, Please try Again!`));
        }, TIME_OUT_SEC * 1000);
    });
};
const $d3824bf2ef2465db$export$a75c676177490cac = async function(API_URL, errMessage) {
    try {
        const res = await Promise.race([
            $d3824bf2ef2465db$var$timeout((0, $ba30e20475feac5a$export$99104383344c6243)),
            fetch(API_URL)
        ]);
        if (!res.ok) throw new Error(`${errMessage}`);
        const data = await res.json();
        return data;
    } catch (err) {
        throw err;
    }
};



const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    flags: [],
    countries: [],
    populations: [],
    regions: [],
    capitals: [],
    results: {
        flags: [],
        countries: [],
        populations: [],
        regions: [],
        capitals: []
    },
    countriesInsideTheRegion: {
        flags: [],
        countries: [],
        populations: [],
        regions: [],
        capitals: []
    },
    displayedCountryDetail: {}
};
const $0f1d4402dffacf5b$export$4e7ab410f5089676 = async function() {
    try {
        const data = await (0, $d3824bf2ef2465db$export$a75c676177490cac)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/all?fields=flags,name,capital,population,continents
`, "wrong countries url");
        for(let i = 0; i < data.length; i++){
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.flags.push(data[i].flags);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.countries.push(data[i].name?.common);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.populations.push(data[i].population);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.regions.push(data[i].continents[0]);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.capitals.push(data[i].capital[0]);
        }
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$be2b23a594353a40 = async function(query) {
    try {
        const result = await (0, $d3824bf2ef2465db$export$a75c676177490cac)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/name/${query}?fields=flags,name,capital,population,continents`, `${(0, $ba30e20475feac5a$export$220312718d013f63)}`);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.capitals = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.flags = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.countries = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.populations = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.regions = [];
        for(let i = 0; i < result.length; i++){
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.flags.push(result[i].flags ? result[i].flags : "No flag Data");
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.countries.push(result[i].name?.common ? result[i].name?.common : "No Country Name data");
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.populations.push(result[i].population ? result[i].population : "No Population data");
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.regions.push(result[i].continents[0] ? result[i].continents : "No Continent data");
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.results.capitals.push(result[i].capital[0] ? result[i].capital : "No Capital City data");
        }
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$bc85ff90fb6c087 = async function(regionQuery) {
    try {
        const result = await (0, $d3824bf2ef2465db$export$a75c676177490cac)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/region/${regionQuery}?fields=flags,name,capital,population,continents`, "wrong region data");
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.capitals = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.flags = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.countries = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.populations = [];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.regions = [];
        for(let i = 0; i < result.length; i++){
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.flags.push(result[i].flags);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.countries.push(result[i].name?.common ? result[i].name?.common : "No Country name data");
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.populations.push(result[i].population ? result[i].population : "No Population data");
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.regions.push(result[i].continents[0] ? result[i].continents[0] : "No Continent data");
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion.capitals.push(result[i].capital[0] ? result[i].capital[0] : "No Capital City data");
        }
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$9276aec8c0cdd52f = async function(countryElement) {
    try {
        const [result] = await (0, $d3824bf2ef2465db$export$a75c676177490cac)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/name/${countryElement}?fullText=true`, `${(0, $ba30e20475feac5a$export$220312718d013f63)}`);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.flag = result.flags;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.countryName = result.name?.common;
        //assigning the value of the nativeName of the country
        if (result.name?.nativeName) {
            const { ...Name } = result.name.nativeName;
            for(const key in Name)if (Name.hasOwnProperty(key)) {
                $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.nativeName = Name[key].common;
                break;
            }
        } else $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.nativeName = "No Native Name";
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.population = result.population;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.region = result.region;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.subRegion = result.subregion ? result.subregion : "No subregion";
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.capital = result.capital ? result.capital : "No capital City";
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.topLevelDomain = result.tld[0] ? result.tld[0] : "No TLD";
        //assigning the value of the currency of the country
        if (result.currencies) {
            const { ...currency } = result.currencies;
            for(const key in currency){
                $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.currency = currency[key].name;
                break;
            }
        } else $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.currency = "No Currency data";
        //assigning the value of the language of the country
        if (result.languages) {
            const { ...language } = result.languages;
            let languages = [];
            for(const key in language)languages.push(language[key]);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.languages = languages.join(", ");
        } else $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.languages = "No Language data";
        //assigning the value of the border of the country
        let borderCountries = result.borders;
        const fetchBorderCountry = async function(borderCode) {
            const res = await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/alpha/${borderCode}`);
            const [data] = await res.json();
            return data.name.common;
        };
        if (borderCountries && borderCountries.length > 0) {
            borderCountries = await Promise.all(borderCountries?.map(async (bordercode)=>{
                return await fetchBorderCountry(bordercode);
            }));
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.borderCountries = borderCountries;
        } else $0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail.borderCountries = [
            "No Border Country"
        ];
    } catch (err) {
        throw err;
    }
};


var $e1086d5c7eb88d8f$exports = {};
$e1086d5c7eb88d8f$exports = new URL("icons.448fab21.svg", import.meta.url).toString();


class $3a395c083ce013f4$export$2e2bcd8739ae039 {
    _parentElement;
    _data;
    _toggle() {
        this._parentElement.classList.toggle("hidden");
    }
    _show() {
        this._parentElement.classList.remove("hidden");
    }
    _hide() {
        this._parentElement.classList.add("hidden");
    }
    renderSpinner() {
        const markup = `
      <div class="spinner">
        <svg aria-hidden="true">
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($e1086d5c7eb88d8f$exports)))}#icon-loader"></use>
        </svg>

        <span class="sr-only">Loading...</span>
      </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _renderErrorMessage(error) {
        const markup = `
    <div class="error">
      <div>
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($e1086d5c7eb88d8f$exports)))}#icon-alert-triangle"></use>
        </svg>
      </div>

      <p role="alert"  tabindex="0" aria-hidden="true">${error}</p>
    </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _render(data) {
        this._data = data;
        const markup = this._generateMarkup();
        this._clear();
        this._parentElement.insertAdjacentHTML("beforeEnd", markup);
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
}


class $ca54546aff1db31f$var$DisplayCountryView extends (0, $3a395c083ce013f4$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".list-of-countries");
    _generateMarkup() {
        const data = [];
        for(let i = 0; i < this._data.flags.length; i++)data.push(`<li class="country" tabindex="0" aria-label="country" role="button">    
        <div class="image-container">
          <img src="${this._data.flags[i].png}" alt="${this._data.flags[i].alt === "" ? "image of the flag" : this._data.flags[i].alt}" class="country__flag" />
      </div>

          <div class="country__container">
            <h2 class="country__name">${this._data.countries[i]}</h2>

            <div class="country__static-container">
              <div class="country__statics">
                <p class="country__statics-title">Population:</p>
                <p class="country__statics-item">${this._data.populations[i]}</p>
              </div>

              <div class="country__statics">
                <p class="country__statics-title">Region:</p>
                <p class="country__statics-item">${this._data.regions[i]}</p>
              </div>

              <div class="country__statics">
                <p class="country__statics-title">Capital:</p>
                <p class="country__statics-item">${this._data.capitals[i]}</p>
              </div>
            </div>
          </div>
        </li>`);
        return data.join("");
    }
}
var $ca54546aff1db31f$export$2e2bcd8739ae039 = new $ca54546aff1db31f$var$DisplayCountryView();





class $e5a20e73880f8a33$var$SearchResultView extends (0, $3a395c083ce013f4$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".find-country__search");
    constructor(){
        super();
        this._addHandlerHidingTheSearchResult();
    }
    _getQuery() {
        const searchInput = document.querySelector(".find-country__search-input");
        const query = searchInput.value;
        return query;
    }
    _clear() {
        const searchResultContainer = document.querySelector(".find-country__search-results-container");
        searchResultContainer.innerHTML = "";
    }
    _clearSearchInputValue() {
        const searchInput = document.querySelector(".find-country__search-input");
        searchInput.value = "";
    }
    renderSpinner() {
        const markup = `
       <div class="spinner">
        <svg aria-hidden="true">
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($e1086d5c7eb88d8f$exports)))}#icon-loader"></use>
        </svg>

        <span class="sr-only">Loading...</span>
      </div>
    `;
        this._clear();
        const searchResultContainer = document.querySelector(".find-country__search-results-container");
        searchResultContainer.insertAdjacentHTML("afterbegin", markup);
    }
    _renderErrorMessage(error) {
        const markup = `
    <div class="error">
      <div>
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($e1086d5c7eb88d8f$exports)))}#icon-alert-triangle"></use>
        </svg>
      </div>

      <p role="alert"  tabindex="0" aria-hidden="true">${error}</p>
    </div>`;
        this._clear();
        const searchResultContainer = document.querySelector(".find-country__search-results-container");
        searchResultContainer.insertAdjacentHTML("afterbegin", markup);
    }
    _render(data) {
        this._data = data;
        const markup = this._generateMarkup();
        this._clear();
        const searchResultContainer = document.querySelector(".find-country__search-results-container");
        searchResultContainer.insertAdjacentHTML("beforeEnd", markup);
    }
    _addHandlerSearchResult(handler) {
        const searchInput = document.querySelector(".find-country__search-input");
        searchInput.addEventListener("keyup", (async function() {
            await handler();
            this._parentElement = document.querySelector(".find-country__search-results");
            this._parentElement.classList.remove("hide-result-list");
            this._parentElement.classList.remove("not-open");
            this._parentElement.classList.add("show-result-list");
        }).bind(this));
    }
    _closeTheSearchResult = function() {
        const searchResults = document.querySelector(".find-country__search-results");
        if (!searchResults.classList.contains("show-result-list")) return;
        this._parentElement = document.querySelector(".find-country__search-results");
        this._parentElement.classList.remove("show-result-list");
        this._parentElement.classList.add("hide-result-list");
        setTimeout(()=>{
            this._parentElement.classList.remove("hide-result-list");
            this._parentElement.classList.add("not-open");
        }, 500);
    };
    _addHandlerHidingTheSearchResult() {
        document.addEventListener("click", (function(e) {
            const searchForm = e.target.closest(".find-country__search");
            if (searchForm) return;
            this._closeTheSearchResult();
        }).bind(this));
    }
    _addHandlerSearchFromTheResults(handler) {
        const searchFromTheResults = (async function(e) {
            const searchResult = e.target.closest(".find-country__search-result");
            if (!searchResult) return;
            const searchQuery = searchResult.textContent.toLowerCase();
            await handler(searchQuery);
            this._closeTheSearchResult();
        }).bind(this);
        this._parentElement.addEventListener("click", searchFromTheResults);
        document.addEventListener("keyup", (async function(e) {
            if (e.key === "Enter" && e.target.closest(".find-country__search-result")) await searchFromTheResults(e);
            else if (e.key === "Tab") {
                const searchResultContainer = document.querySelector(".find-country__search-results-container");
                const lastSearchResult = searchResultContainer.lastElementChild;
                if (document.activeElement === lastSearchResult) document.addEventListener("focusin", (function(event) {
                    // Check if the next focused element is outside the search results container
                    if (!searchResultContainer.contains(event.target)) // Close the search results
                    this._closeTheSearchResult();
                }).bind(this), {
                    once: true
                });
            }
        }).bind(this));
    }
    _addHandlerSearchFromTheFormSubmitted(handler) {
        this._parentElement.addEventListener("submit", (async function(e) {
            e.preventDefault();
            await handler(this._getQuery());
            this._clearSearchInputValue();
        }).bind(this));
    }
    _renderCountry(searchResultData) {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039)._render(searchResultData);
    }
    _generateMarkup() {
        const data = [];
        for(let i = 0; i < this._data.flags.length; i++)data.push(` <li role="button" tabindex="0" class="find-country__search-result result-${i + 1}">${this._data.countries[i]}</li>`);
        return data.join("");
    }
}
var $e5a20e73880f8a33$export$2e2bcd8739ae039 = new $e5a20e73880f8a33$var$SearchResultView();



class $ec5be834ab5be619$var$ShowCountryDetailView extends (0, $3a395c083ce013f4$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".page-detail");
    constructor(){
        super();
    }
    _addHandlerBackToTheHomePage(handler) {
        const backToHomePage = function(e) {
            const backBtn = e.target.closest(".back-btn");
            if (!backBtn) return;
            handler();
        };
        this._parentElement.addEventListener("click", backToHomePage);
        this._parentElement.addEventListener("keyup", function(e) {
            if (e.key === "Enter") backToHomePage();
        });
    }
    _addHanlderShowCountryDetail(handler) {
        const listOfCountries = document.querySelector(".list-of-countries");
        const showCountryDetail = function(e) {
            const clickedCountryItem = e.target.closest(".country");
            if (!clickedCountryItem) return;
            const countryName = clickedCountryItem.querySelector(".country__name").textContent.trim();
            handler(countryName);
        };
        listOfCountries.addEventListener("click", function(e) {
            showCountryDetail(e);
        });
        listOfCountries.addEventListener("keyup", function(e) {
            if (e.key === "Enter") showCountryDetail(e);
        });
    }
    _generateMarkup() {
        return `   <button class="back-btn" aria-label="Back To Previous page">
          <span class="fa-solid fa-arrow-left"></span>
          Back
        </button>

        <div class="page-detail__info">
          <img
            class="page-detail__info-img"
            src="${this._data.flag.png}"
            alt="${this._data.flag.alt ? this._data.flag.alt : "flag of the country"}"
          />

          <div class="page-detail__info-text">
            <h2 class="page-detail__country-name">${this._data.countryName}</h2>

             <div class="page-detail__info-wrapper">
            <div class="page-detail__info-text-part-1">
              <div class="page-detail__text-item">
                <!--native-name-->
                <p class="page-detail__text-item-title">native name:</p>
                <p class="page-detail__text-item-content">${this._data.nativeName}</p>
              </div>

              <div class="page-detail__text-item">
                <p class="page-detail__text-item-title">Populations:</p>
                <p class="page-detail__text-item-content">${this._data.population}</p>
              </div>

              <div class="page-detail__text-item">
                <p class="page-detail__text-item-title">Regions:</p>
                <p class="page-detail__text-item-content">${this._data.region}</p>
              </div>

              <div class="page-detail__text-item">
                <p class="page-detail__text-item-title">Sub Region:</p>
                <p class="page-detail__text-item-content">${this._data.subRegion}</p>
              </div>

              <div class="page-detail__text-item">
                <p class="page-detail__text-item-title">Capital:</p>
                <p class="page-detail__text-item-content">${this._data.capital}</p>
              </div>
            </div>

            <div class="page-detail__info-text-part-2">
              <div class="page-detail__text-item">
                <p class="page-detail__text-item-title">Top Level Domain:</p>
                <p class="page-detail__text-item-content">${this._data.topLevelDomain}</p>
              </div>

              <div class="page-detail__text-item">
                <p class="page-detail__text-item-title">Currencies:</p>
                <p class="page-detail__text-item-content">${this._data.currency}</p>
              </div>

              <div class="page-detail__text-item">
                <p class="page-detail__text-item-title">Languages:</p>
                <p class="page-detail__text-item-content">
               ${this._data.languages}
                </p>
              </div>
            </div>
       </div>

            <div class="page-detail__info-text-part-3">
              <p
                class="page-detail__text-item-title page-detail__text-item-title--size-2"
              >
                Border Countries:
              </p>

              <ul class="page-detail__text-item-container">
              ${this._data.borderCountries.map(this._displayBorderCountries).join("")}
            </ul>
            </div>
          </div>
        </div>`;
    }
    _displayBorderCountries(borderCountry) {
        return `<li class="page-detail__text-item-border" tabindex = "0" aria-label="border country" role="button">${borderCountry}</li>`;
    }
    _addHandlerShowBorderCountryDetail(handler) {
        const showCountryDetail = function(e) {
            const borderCountry = e.target.closest(".page-detail__text-item-border");
            if (!borderCountry) return;
            const borderCountryName = borderCountry.textContent.trim();
            handler(borderCountryName);
        };
        this._parentElement.addEventListener("click", showCountryDetail);
        this._parentElement.addEventListener("keyup", function(e) {
            if (e.key === "Enter") showCountryDetail(e);
        });
    }
}
var $ec5be834ab5be619$export$2e2bcd8739ae039 = new $ec5be834ab5be619$var$ShowCountryDetailView();



class $a41e34ed912568fa$var$homePageView extends (0, $3a395c083ce013f4$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".home-page");
    _darkModeToggler = document.querySelector(".theme-switcher");
    constructor(){
        super();
        this._darkModeToggle();
    }
    _toogleMode() {
        const body = document.querySelector("body");
        const themeSwitcherSrOnlyText = document.querySelector(".theme-switcher__icon").querySelector(".sr-only");
        const themeSwitcherMode = document.querySelector(".theme-switcher__mode");
        if (themeSwitcherSrOnlyText.textContent.includes("light mode")) {
            themeSwitcherSrOnlyText.textContent = "the page is in dark mode";
            body.classList.add("dark");
            this._darkModeToggler.setAttribute("aria-pressed", "true");
        } else {
            themeSwitcherSrOnlyText.textContent = "the page is in light mode";
            body.classList.remove("dark");
            this._darkModeToggler.setAttribute("aria-pressed", "false");
        }
    }
    _darkModeToggle() {
        this._darkModeToggler.addEventListener("click", this._toogleMode.bind(this));
        this._darkModeToggler.addEventListener("keyup", (function(e) {
            if (e.key === "Enter") this._toogleMode();
        }).bind(this));
    }
    _addHandlerClickOnWhereInTheWorld(handler) {
        const title = document.querySelector(".title");
        title.addEventListener("keyup", function(e) {
            if (e.key === "Enter") handler();
        });
        title.addEventListener("click", function() {
            handler();
        });
    }
}
var $a41e34ed912568fa$export$2e2bcd8739ae039 = new $a41e34ed912568fa$var$homePageView();


// import "core-js/stable";
const $f50bd1f2915ed0f2$var$controlDisplayAllCountriesData = async function() {
    try {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039).renderSpinner();
        await $0f1d4402dffacf5b$export$4e7ab410f5089676();
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039)._render({
            flags: $0f1d4402dffacf5b$export$ca000e230c0caa3e.flags,
            countries: $0f1d4402dffacf5b$export$ca000e230c0caa3e.countries,
            regions: $0f1d4402dffacf5b$export$ca000e230c0caa3e.regions,
            capitals: $0f1d4402dffacf5b$export$ca000e230c0caa3e.capitals,
            populations: $0f1d4402dffacf5b$export$ca000e230c0caa3e.populations
        });
    } catch (err) {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039)._renderErrorMessage(err);
    }
};
const $f50bd1f2915ed0f2$var$controlSearchResult = async function() {
    try {
        const query = (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._getQuery();
        if (!query) return;
        (0, $e5a20e73880f8a33$export$2e2bcd8739ae039).renderSpinner();
        await $0f1d4402dffacf5b$export$be2b23a594353a40(query);
        (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._render($0f1d4402dffacf5b$export$ca000e230c0caa3e.results);
    } catch (err) {
        (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._renderErrorMessage(err);
    }
};
const $f50bd1f2915ed0f2$var$controlSearchFromResult = async function(searchQuery) {
    try {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039).renderSpinner();
        await $0f1d4402dffacf5b$export$be2b23a594353a40(searchQuery);
        (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._renderCountry($0f1d4402dffacf5b$export$ca000e230c0caa3e.results);
        (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._clearSearchInputValue();
    } catch (err) {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039)._renderErrorMessage(err);
    }
};
const $f50bd1f2915ed0f2$var$controlFilterCountriesByRegion = async function(regionQuery) {
    try {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039).renderSpinner();
        await $0f1d4402dffacf5b$export$bc85ff90fb6c087(regionQuery);
        (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._renderCountry($0f1d4402dffacf5b$export$ca000e230c0caa3e.countriesInsideTheRegion);
    } catch (err) {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039)._renderErrorMessage(err);
    }
};
const $f50bd1f2915ed0f2$var$controlShowCountriesDetail = async function(countryElement) {
    try {
        (0, $a41e34ed912568fa$export$2e2bcd8739ae039)._toggle();
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._toggle();
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039).renderSpinner();
        await $0f1d4402dffacf5b$export$9276aec8c0cdd52f(countryElement);
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._render($0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail);
    } catch (err) {
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._renderErrorMessage(err);
        console.log(err);
    }
};
const $f50bd1f2915ed0f2$var$contorlShowBorderCountryDetail = async function(borderCountryElement) {
    try {
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039).renderSpinner();
        await $0f1d4402dffacf5b$export$9276aec8c0cdd52f(borderCountryElement);
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._render($0f1d4402dffacf5b$export$ca000e230c0caa3e.displayedCountryDetail);
    } catch (err) {
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._renderErrorMessage(err);
    }
};
const $f50bd1f2915ed0f2$var$controlBackToTheHomePage = function() {
    (0, $a41e34ed912568fa$export$2e2bcd8739ae039)._toggle();
    (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._toggle();
};
const $f50bd1f2915ed0f2$var$controlBackToTheHomePageWithClickingTheTitle = async function() {
    try {
        (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._hide();
        (0, $a41e34ed912568fa$export$2e2bcd8739ae039)._show();
        await $f50bd1f2915ed0f2$var$controlDisplayAllCountriesData();
    } catch (err) {
        (0, $ca54546aff1db31f$export$2e2bcd8739ae039)._renderErrorMessage(err);
    }
};
const $f50bd1f2915ed0f2$var$init = function() {
    $f50bd1f2915ed0f2$var$controlDisplayAllCountriesData();
    (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._addHandlerSearchResult($f50bd1f2915ed0f2$var$controlSearchResult);
    (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._addHandlerSearchFromTheResults($f50bd1f2915ed0f2$var$controlSearchFromResult);
    (0, $e5a20e73880f8a33$export$2e2bcd8739ae039)._addHandlerSearchFromTheFormSubmitted($f50bd1f2915ed0f2$var$controlSearchFromResult);
    (0, $c9f2caaecf229584$export$2e2bcd8739ae039)._addHandlerFilterByRegion($f50bd1f2915ed0f2$var$controlFilterCountriesByRegion);
    (0, $c9f2caaecf229584$export$2e2bcd8739ae039)._addHandlerNavigationByKeyboard($f50bd1f2915ed0f2$var$controlFilterCountriesByRegion);
    (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._addHanlderShowCountryDetail($f50bd1f2915ed0f2$var$controlShowCountriesDetail);
    (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._addHandlerBackToTheHomePage($f50bd1f2915ed0f2$var$controlBackToTheHomePage);
    (0, $ec5be834ab5be619$export$2e2bcd8739ae039)._addHandlerShowBorderCountryDetail($f50bd1f2915ed0f2$var$contorlShowBorderCountryDetail);
    (0, $a41e34ed912568fa$export$2e2bcd8739ae039)._addHandlerClickOnWhereInTheWorld($f50bd1f2915ed0f2$var$controlBackToTheHomePageWithClickingTheTitle);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.f30ab698.js.map
